import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=689580df&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689580df')) {
      api.createRecord('689580df', component.options)
    } else {
      api.reload('689580df', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=689580df&", function () {
      api.rerender('689580df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/steps.vue"
export default component.exports